<template>
  <div class="options-menu-wrapper"
      :class="{'options-menu-wrapper--disabled': !options.length }"
      :ref="id"
      @click.stop.prevent>
    <div class="options-menu-button" :class="{'options-menu-button--open': open }" @click.stop.prevent="toggleState(!open)">
      <sword-icon-wuk
        class="options-menu-button__icon"
        name="options"
      />
    </div>
    <div class="options-menu-container" :class="{ open: open }">
      <options-list-wuk
        :options="options"
        :item-align="itemAlign"
        @click="(option) => selectOption(option.optValue)"
        @linkClick="toggleState(false)"
      >
      </options-list-wuk>
    </div>
    <mobile-options-list-wuk
      class="mobile-options-menu-container"
      :show="open"
      :heading="$t(mobileHeading)"
      :options="options"
      :item-align="itemAlign"
      @change="selectOption"
      @closed="toggleState(false)"
    >
    </mobile-options-list-wuk>
  </div>
</template>

<script>
import MobileOptionsListWuk from '@ui-kit/components/inputs/options-lists/mobileOptionsList.vue';
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';
import OptionsListWuk from './OptionsList.vue';

export default {
  name: 'optionsMenuWuk',
  components: { MobileOptionsListWuk, OptionsListWuk, SwordIconWuk },
  props: {
    options: {
      type: Array,
      required: true,
    },
    mobileHeading: {
      type: String,
      default: 'copy_4198',
    },
    itemAlign: {
      type: String,
      validator: value => ['center', 'start', 'end'].includes(value),
    }
  },
  data() {
    return {
      open: false,
      id: null
    };
  },
  methods: {
    toggleState(state) {
      this.open = state;
      this.$emit('toggle', state);
    },
    selectOption(option) {
      this.$emit('option-clicked', option);
      this.toggleState(false);
    },
    handleOnBlur($event) {
      if (!this.$refs[this.id].contains($event.target)) {
        this.toggleState(false);
      }
    }
  },
  mounted() {
    this.id = this._uid;
    document.addEventListener('click', this.handleOnBlur);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOnBlur);
  },
};
</script>

<style lang="scss" scoped>
$button-size: 2.5rem;
$form-option-toggle-size: 2.25rem;

.options-menu-wrapper {
  position: relative;
  width: max-content;
  transition: background-color 0.3s ease-in-out;

  .options-menu-button {
    width: $button-size;
    height: $button-size;
    padding: map-get($sh-spacers-wuk, 1);
    margin: 0;
    border-radius: 100%;
    transition: box-shadow 100ms linear;
    cursor: pointer;
    display: flex;

    &__icon {
      width: 1.5rem;
      height: 1.5rem;
      transform: rotate(90deg);
    }

    &--open {
      background-color: $context-color-6;
    }
  }

  .options-menu-container {
    position: absolute;
    top: 2.75rem;
    right: 0;
    padding: 0.5rem 0;
    min-width: 20rem;
    border-radius: 0.25rem;
    box-shadow: 0 2px 10px 0 $shadow-wuk;
    background-color: $white;
    text-align: left;
    z-index: 2;
    overflow: hidden;

    &:not(.open) {
      display: none;
    }

    &::v-deep {
      .options-list-item  {
        flex-direction: row-reverse;
        padding: 0.5rem 1rem;
        font-size: 1rem;

        &:hover {
          color: revert;
          background-color: $context-color-7;
        }
      }
    }
  }

  .mobile-options-menu-container {
     &::v-deep {
      .options-list-item  {
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-end;
      }
    }
  }

  &:hover {
    .options-menu-button {
      background-color: $context-color-6;
    }
  }

  &--disabled {
    opacity: 0.4;
    pointer-events: none;
    cursor: default;
  }
}

@media screen and (max-width: $max-smartphone-size) {
  .options-menu-container {
    display: none;
  }
}

@media screen and (min-width: $min-tablet-size) {
  .mobile-options-menu-container {
    display: none;
  }
}

</style>
